// extracted by mini-css-extract-plugin
export default {"page_title":"PageTitle_page_title__RyVoO"};